import { eAtlas, eSfxSprite, Game } from "../../Game";
import { IDictionary } from "../../Utils/Collections/Dictionary";
import { Pool } from "../../Utils/Collections/Pool";
import { WrappedArray } from "../../Utils/Collections/WrapperArray";
import { eGameplayState, Gameplay, TIMER } from "../Gameplay";
import { HUD } from "../HUD/HUD";
import { Ball, eKickOffResult } from "../Player/Ball";
import { RoundManager } from "../Round/RoundManager";
import { Stadium } from "../Stadium/Stadium";
import { TextPopup } from "../TextPopup";
import { FireRingTarget } from "./Targets/FireRingTarget";
import { TargetControllerBase } from "./Controllers/BaseController";
import { MovingTargetController, MovingTargetSettings } from "./Controllers/MovingController";
import { StaticTargetController, StaticTargetSettings } from "./Controllers/StaticController";
import { SwitchPosTargetController, SwitchPosTargetSettings } from "./Controllers/SwitchPosController";
import { RoundTarget } from "./Targets/RoundTarget";
import { eTargetState, TargetBase } from "./Targets/Target";
import { TargetHitEntry } from "./TargetHitEntry";
import { TargetHitFx } from "./TargetHitFx";
import { TargetSettingsBase } from "./TargetSettings";
import { TargetShards } from "./TargetShard";
import { eTargetType, TargetType } from "./TargetType";
import { TargetZone } from "./TargetZone";
import { CornerTarget } from "./Targets/CornerTarget";
import { CornerTargetController, CornerTargetSettings } from "./Controllers/CornerController";
import { TrajectoryDisplayer } from "./Trajectory Displayer/TrajectoryDisplayer";
import { MovingTarTrajDis } from "./Trajectory Displayer/MovingTargetTrajectory";
import { SwitchPosTarTrajDis } from "./Trajectory Displayer/SwitchPosTargetTrajectory";
import { TargetScaler } from "./TargetScaling";
import { RepData } from "../../ReplayData";
import { AtlasAnimClipData } from "../../Utils/Atlas/AtlasAnimClip";
import { eAnimMsgBgFx } from "../HUD/AnimMessages/AnimMessageManager";
import { BonusTarget } from "./Targets/BonusTarget";
import { eMissionType } from "../../Publisher API/Gamee/MissionManager";



export class TargetManager {
    static get instance(): TargetManager { return TargetManager._instance; }
    private static _instance: TargetManager;

    /**
     * Typy tercu
     */
    private _targetTypes: TargetType[];
    /**
     * Pool s volnymi terci pro jednotlive typy [eTargetType]
     */
    private _freeTargets: Pool<TargetBase>[];
    /**
     * (RO) Pole s aktivnimi cili
     */
    get actTargets(): TargetBase[] { return this._actTargets; }
    private _actTargets: TargetBase[];
    /**
     * (RO) Hlavni terc, ktery ma hrac zasahnout
     */
    get mainTarget(): RoundTarget { return this._mainTarget; }
    private _mainTarget: RoundTarget;
    /**
     * Zmena velikosti hlavniho terce
     */
    private _mainTargetScaler: TargetScaler;

    private _bonusTarget: TargetBase;
    /**
     * Pooly s ovladaci tercu
     */
    private _ctrlPools: IDictionary<Pool<TargetControllerBase>> = {};
    /**
     * Maximalni hodnota nasobice skore
     */
    private static readonly MAX_SCORE_MULTIPLIER = 5;
    /**
     * (RO) Aktualni hodnota nasobeni skore za zasah terce (ktery nasobeni podporuje)
     */
    get scoreMultiplier(): number { return this._scoreMultiplier; }
    private _scoreMultiplier: number;
    /**
     * Seznam zasahu terce pro aktualni kolo
     */
    private _hitEntries: TargetHitEntry[] = [];
    /**
     * Pooly se spravci ulomku terce pro jednotlive typy tercu [eTargetType]
     */
    private _freeShards: IDictionary<Pool<TargetShards>> = {};
    private _actShards: WrappedArray<TargetShards>;
    private _shardsBatchGroupId: number;

    /**
     * (RO) Batch ktera obsahuje ulomky tercu
     */
    get shardBatch(): pc.Batch { return this._shardBatch; }
    private _shardBatch: pc.Batch;
    /**
     * Efekt zasahu terce
     */
    private _hitFx: TargetHitFx;
    /**
     * Zobrazovace trajektorie pro jednotlive typy ovladacu terce
     */
    private _trajectoryDisplayers: IDictionary<TrajectoryDisplayer>;
    /**
     * Aktualni zobrazovat trajektorie hlavniho terce
     */
    private _curTrajectDisplayer: TrajectoryDisplayer;

    private _animMsgTexts: AtlasAnimClipData[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        TargetManager._instance = this;

        // Typy tercu
        this._targetTypes = [
            // Kulaty terc
            new TargetType(eTargetType.round, [new TargetZone(0, 0, 100, 300, 30)], [73, 65, 58, 88, 64, 115, 87, 132, 114, 128, 133, 107, 134, 85, 121, 66, 98, 57, 50, 37, 23, 82, 33, 135, 78, 166, 133, 159, 166, 121, 167, 74, 144, 37, 99, 20]),
            // Ohnivy kruh
            new TargetType(eTargetType.fireRing, [new TargetZone(0, 0, 80, 0, 0)]),
            // Rohovy terc
            new TargetType(eTargetType.corner, [new TargetZone(0, 0, 100, 15, 15)], [6, 28, 20, 20, 30, 6, 14, 52, 39, 40, 55, 13, 17, 77, 59, 58, 80, 18]),
            // Bonus
            new TargetType(eTargetType.bonus, [new TargetZone(0, 0, 100, 50, 50)])
        ];

        // Zmena velikosti hlavniho terce
        this._mainTargetScaler = new TargetScaler();

        // Ulomky tercu
        this._shardsBatchGroupId = Game.app.batcher.addGroup("targetShards", true, 100).id;
        Game.app.on("batch:created" + this._shardsBatchGroupId, (batch: pc.Batch) => { this._shardBatch = batch; });

        this._freeShards[eTargetType.round] = new Pool<TargetShards>(undefined, 1, true, (): TargetShards => {
            return new TargetShards(this._targetTypes[eTargetType.round], this._shardsBatchGroupId);
        });
        this._freeShards[eTargetType.corner] = new Pool<TargetShards>(undefined, 1, true, (): TargetShards => {
            return new TargetShards(this._targetTypes[eTargetType.corner], this._shardsBatchGroupId);
        });

        this._actShards = new WrappedArray<TargetShards>();

        // Efekt zasahu do terce
        this._hitFx = new TargetHitFx();

        // Pool volnych tercu
        this._freeTargets = [];

        this._freeTargets[eTargetType.round] = new Pool<RoundTarget>(undefined, 1, true, (): RoundTarget => { return new RoundTarget(this, this._targetTypes[eTargetType.round]); });
        this._freeTargets[eTargetType.fireRing] = new Pool<FireRingTarget>(undefined, 1, true, (): FireRingTarget => { return new FireRingTarget(this, this._targetTypes[eTargetType.fireRing]); });
        this._freeTargets[eTargetType.corner] = new Pool<CornerTarget>(undefined, 1, true, (): CornerTarget => { return new CornerTarget(this, this._targetTypes[eTargetType.corner]); });
        this._freeTargets[eTargetType.bonus] = new Pool<BonusTarget>(undefined, 1, true, (): BonusTarget => { return new BonusTarget(this, this._targetTypes[eTargetType.bonus]); });

        // Seznam aktivnich tercu
        this._actTargets = []

        // Pooly s ovladaci tercu v IDictionary, kde klic je jmeno tridy s nastavenim ovladace
        this._ctrlPools[StaticTargetSettings.name] = new Pool<StaticTargetController>(StaticTargetController, 0, true);
        this._ctrlPools[MovingTargetSettings.name] = new Pool<MovingTargetController>(MovingTargetController, 0, true);
        this._ctrlPools[SwitchPosTargetSettings.name] = new Pool<SwitchPosTargetController>(SwitchPosTargetController, 0, true);
        this._ctrlPools[CornerTargetSettings.name] = new Pool<CornerTargetController>(CornerTargetController, 0, true);

        // Nasobeni skore
        this._scoreMultiplier = 1;

        // Zobrazeni trajektorie hlavniho terce
        this._trajectoryDisplayers = {};
        this._trajectoryDisplayers[MovingTargetSettings.name] = new MovingTarTrajDis();
        this._trajectoryDisplayers[SwitchPosTargetSettings.name] = new SwitchPosTarTrajDis();

        // Animovane textove zpravy
        this._animMsgTexts = [
            new AtlasAnimClipData(Game.getAtlas(eAtlas.texts), "fireball/", 25, 0, 20),
            new AtlasAnimClipData(Game.getAtlas(eAtlas.texts), "perfect/", 25, 0, 20),
            new AtlasAnimClipData(Game.getAtlas(eAtlas.texts), "nice/", 25, 0, 20),
        ];

        // Zachytavat zpravy
        let events = Gameplay.instance.events;

        events.on(Ball.EVENT_KICKED_OFF1, this.handleBallKickedOff, this);
        events.on(Ball.EVENT_FLIGHT_END, this.handleBallFlightEnd, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(): void {
        let roundMng = RoundManager.instance;
        let roundSetup = roundMng.roundSetup;

        // Uvolnit aktivni spravce ulomku terce
        this._actShards.forEach((shards: TargetShards): void => {
            this._freeShards[shards.targetType].returnItem(shards);
            shards.reset();
        });
        this._actShards.clear(false);

        // Reset efektu zasahu
        this._hitFx.reset();

        if (roundMng.roundAttemptId == 0) {
            // Uvolnit aktivni terce
            this._actTargets.forEach((target: TargetBase): void => {
                this._ctrlPools[(<any>target.settings).constructor.name].returnItem(target.controller);
                this._freeTargets[target.type.type].returnItem(target);
                target.reset();
            });
            this._actTargets.length = 0;
            this._mainTarget = null;
            this._bonusTarget = null;

            // Deaktivovat zobrazovac trajektorie
            if (this._curTrajectDisplayer) {
                this._curTrajectDisplayer.reset();
                this._curTrajectDisplayer = undefined;
            }

            // Aktivovat terce            
            roundSetup.targets.forEach((s: TargetSettingsBase, i: number) => {
                if (s.type != eTargetType.corner)
                    //if (s.type == eTargetType.round || (s.type == eTargetType.fireRing && !isFireBall))
                    this.activateTarget(i, s);
            });

            this._mainTargetScaler.reset();

            if (roundSetup.mainTargetScaling)
                this._mainTargetScaler.init(roundSetup.mainTargetScaling);
        }
        else {
            // Pokud je bonusovy terc, tak ho zrusit
            if (this._bonusTarget) {
                let target = this._bonusTarget;

                this._ctrlPools[(<any>target.settings).constructor.name].returnItem(target.controller);
                this._freeTargets[target.type.type].returnItem(target);
                this._actTargets.splice(this._actTargets.length - 1, 1);
                target.reset();
                this._bonusTarget = null;
            }

            // Restart aktualnich tercu           
            this._actTargets.forEach((target: TargetBase): void => {
                target.restart();
            });

            if (roundMng.roundAttemptId == 1) {
                // Doplnit rohovy terc
                if (roundSetup.targets.first.type == eTargetType.corner) {
                    this.activateTarget(0, roundSetup.targets.first);
                }
            }

            // Trajektorie hlavniho terce
            if (this._curTrajectDisplayer)
                this._curTrajectDisplayer.show(this._mainTarget);
        }

        // Resetovat seznam zasahu
        this._hitEntries.length = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Aktivni terce
        this._actTargets.forEach((target: TargetBase) => { target.update(); });

        // Zmena velikosti hlavniho terce
        if (this._mainTargetScaler.isActive && this._mainTarget.state == eTargetState.idle)
            this._mainTarget.scale = this._mainTargetScaler.getScale(TIMER.time - RoundManager.instance.roundStartTime);

        // Zobrazeni trajektorie terce
        if (this._curTrajectDisplayer)
            this._curTrajectDisplayer.update();

        // Aktivni ulomky tercu
        if (!this._actShards.empty) {
            this._actShards.forEach((shards: TargetShards): void => {
                if (!shards.update()) {
                    this._actShards.remove(false);
                    this._freeShards[shards.targetType].returnItem(shards);
                }
            });
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci data typu terce
     * @param type 
     * @returns 
     */
    //-------------------------------------------------------------------------
    getTargetType(type: eTargetType): TargetType { return this._targetTypes[type]; }

    //-------------------------------------------------------------------------
    /**
     * Aktivace ulomku pro zadany terc
     * @param target 
     */
    //-------------------------------------------------------------------------
    activateShards(version: number, target: TargetBase): void {
        let shards = this._freeShards[target.type.type].getItem();

        shards.activate(target, version);
        this._actShards.add(shards);

        this._shardBatch = undefined;
        Game.app.batcher.markGroupDirty(this._shardsBatchGroupId);
    }

    //-------------------------------------------------------------------------
    /**
     * Ulozit zaznam o zasahu
     * @param entry 
     */
    //-------------------------------------------------------------------------
    addHitEntry(entry: TargetHitEntry): void {
        if (Ball.instance.kickOffFinalRes == eKickOffResult.none) {
            this._hitEntries.push(entry);

            if (!this._hitFx.isActive && entry.target.type.type != eTargetType.fireRing) {
                this._hitFx.activate(new pc.Vec3(entry.ballPos.x, entry.ballPos.y, entry.target.container.getPosition().z + 0.1));
            }
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vyhodnoceni zasahu
     * @returns 
     */
    //-------------------------------------------------------------------------
    evaluateHits(): boolean {
        if (this._hitEntries.length == 0)
            return false;

        let gameplay = Gameplay.instance;

        if (gameplay.state == eGameplayState.play) {
            // Vypocitat skore a nasobic
            let ball = Ball.instance;
            let score = 0;
            let multiplier = 1
            let incMultiplier = false;
            let isFireRing = false;
            let isBullsEye = false;
            let isBonus = false;
            let isFireball = ball.fireBallState == 1;

            this._hitEntries.forEach((hitEntry: TargetHitEntry): void => {
                let target = hitEntry.target;
                let targetType = target.type.type;

                score += hitEntry.rawScore;

                if (target.scoreMultiplier > multiplier)
                    multiplier = target.scoreMultiplier;

                if (targetType == eTargetType.round) {
                    incMultiplier = true;

                    if (hitEntry.hitRadiusRatio < RoundTarget.CENTER_RADIUS) {
                        score += RoundTarget.CENTER_BONUS_SCORE;
                        isBullsEye = true;
                    }
                }
                else if (targetType == eTargetType.fireRing) {
                    isFireRing = true;
                }
                else if (targetType == eTargetType.bonus) {
                    isBonus = true;
                }
            });

            if ((isFireRing || isBonus) && this._hitEntries.length == 1) {
                // Pouze zasah do ohniveho kruhu nebo bonusoveho terce
                this._hitEntries.length = 0;
                return false;
            }

            // Replay data
            gameplay.events.fire(RepData.EVENT_SAVE_HITS, this._hitEntries);

            // Navysit skore       
            if (isFireball)
                score *= 2;

            gameplay.score += score * multiplier;

            // Navyseni nasobice
            if (incMultiplier && RoundManager.instance.roundAttemptId == 0 && this._scoreMultiplier < TargetManager.MAX_SCORE_MULTIPLIER)
                this._scoreMultiplier++;

            // Postup k fire ballu        
            let prevFireBallState = ball.fireBallState;

            if (isFireRing)
                ball.incFireBallState();

            // Zobrazit vyskakovaci zpravu
            let pos = this._hitEntries[0].ballPos;

            (gameplay.scorePopups.activateItem() as TextPopup).show(pos.x, pos.y, Stadium.END_Z + 1, (multiplier == 1 ? "+" : "+" + multiplier + "x") + score, isFireball ? 1 : 0);

            let missions = Game.missions;

            if (missions)
                missions.incMissionProgress(eMissionType.hitTarget5);

            // Zobrazit slidovaci zpravu
            if (isFireRing && prevFireBallState != 1 && ball.fireBallState == 1) {
                HUD.instance.animMessage.showMessage(0.4, eAnimMsgBgFx.fireball, this._animMsgTexts[0]);
                Game.playSound(eSfxSprite.fireballOn);

                if (missions)
                    missions.incMissionProgress(eMissionType.getFireBall);
            }
            else if (isBullsEye) {
                HUD.instance.animMessage.showMessage(0.4, eAnimMsgBgFx.success, this._animMsgTexts[1]);
                Game.playSound(eSfxSprite.bullsEye);

                if (missions)
                    missions.incMissionProgress(eMissionType.hitTargetCenter);
            }
            else if (isFireRing) {
                HUD.instance.animMessage.showMessage(0.4, eAnimMsgBgFx.success, this._animMsgTexts[2]);
            }

            if (isBonus) {
                Game.playSound(eSfxSprite.bonus);
            }
        }

        // Vymazat seznam zasahu
        this._hitEntries.length = 0;

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private activateTarget(targetId: number, settings: TargetSettingsBase): void {
        let isFireBall = Ball.instance.fireBallState == 1;
        let type = settings.type;

        // Pokud je typ terce "fireRing" a hrac ma fireball, tak zmenit typ terce na bonusovy
        if (type == eTargetType.fireRing && isFireBall)
            type = eTargetType.bonus;

        // Ziskat objekt pro terc
        let target = this._freeTargets[type].getItem();

        // Ziskat ovladac pro terc podle tridy objektu s nastavenim
        let controller = this._ctrlPools[(<any>settings).constructor.name].getItem();

        // Aktivovat terc
        target.activate(targetId, settings, controller, this._actTargets[this._actTargets.length - 1]);
        this._actTargets.push(target);

        if (!this._mainTarget && target.type.type == eTargetType.round) {
            let displayer = this._trajectoryDisplayers[(<any>target.settings).constructor.name];

            if (displayer) {
                displayer.show(target);
                this._curTrajectDisplayer = displayer;
            }

            this._mainTarget = target as RoundTarget;
        }
        else if (type == eTargetType.bonus) {
            this._bonusTarget = target;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBallKickedOff(): void {
        if (this._curTrajectDisplayer)
            this._curTrajectDisplayer.hide();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBallFlightEnd(res: eKickOffResult): void {
        if (Gameplay.instance.state == eGameplayState.play) {
            if (res != eKickOffResult.target) {
                // Pokud nedoslo k zasahu terce, tak resetovat nasobeni
                this._scoreMultiplier = 1;
            }
        }
    }
}